import * as React from "react";
import InputTextField from "shubhform/fields/InputTextField";
import InputSelectField from "shubhform/fields/InputSelectField";
import RadioButtonField from "shubhform/fields/RadioButtonField";
import {getDefaultStyles, getModifiedStyles, InputType} from "shubhform/utils";
import UploadDoc from "shubhform/fields/uploadDoc";
import InputDateField from "shubhform/fields/inputDateField";

interface IInputStyles {
    handleTextFieldStyle?: (arg: boolean) => object;
    handleDropdownStyle?: (arg: boolean) => object;
    handleRadioStyle?: (arg: boolean) => object;
    handleUploadDocStyle?: (arg: boolean) => object;
    handleDateStyle?: (arg: boolean) => object;
}

interface IStyles {
    handleContainerStyle?: (arg: boolean) => object;
    inputStyle?: IInputStyles;
    handleErrorStyle?: (arg: boolean) => object;
    submitButtonStyle?: object;
    headerStyle?: object;
}

interface IProps {
    fields: any;
    onSubmit: any;
    onValidate?: any;
    headerTitle?: string;
    submitTitle?: string;
    customStyles?: IStyles;
    onChangeHook?: (fieldDetails: any) => object;
    additionalBottomField?: any;
    hideDefaultSubmit?: boolean;
    errors?: any;
    successfulyUploaded?: any;
    isDatePicker?: boolean;
}
interface IState {
    fieldDetails: any;
    errors: any;
}
interface IFormField {
    inputType: string;
    placeholder?: string;
    label?: string;
    name: string;
    value: string | number;
    handleOnChange?: any;
    radioButtonList?: IRadioButton[];
    errorMsg: string;
}

interface IRadioButton {
    name: string;
    value: string;
    placeholder: string;
    fieldName: string;
    checked: boolean;
    id: string;
}
let currentStyle: IStyles = null ;
export default class ShubhForm extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        currentStyle = props.customStyles ?
            getModifiedStyles(getDefaultStyles(), props.customStyles) : getDefaultStyles();
        this.state = {
            fieldDetails: props.fields,
            errors: this.props.errors ? this.props.errors : null,
        };
    }
    public validateFields = () => {
        return this.props.onValidate(this.state.fieldDetails);
    }
    public submitForm = (event) => {
        event.preventDefault();
        const validation = this.validateFields();
        if (validation.status) {
            this.props.onSubmit(this.state.fieldDetails);
        }
        this.setState({errors: validation.errors});
    }
    public handleChange = (index, value) => {
        const fieldDetails = this.state.fieldDetails;
        fieldDetails[index].value = value;
        if (this.props.onChangeHook) {
            fieldDetails[index] = this.props.onChangeHook(this.state.fieldDetails[index]);
        }
        this.setState({
            ...this.state,
            fieldDetails,
        });
    }
    public getCurrentStyles = (fieldName, errors, inputField) => {
        const hasError = errors && errors.hasOwnProperty(fieldName);
        return{
            containerStyle: currentStyle.handleContainerStyle(hasError),
            inputStyle: currentStyle.inputStyle[inputField](hasError),
            errorStyle: currentStyle.handleErrorStyle(hasError),
        };
    }
    public componentWillReceiveProps(nextProps: Readonly<IProps>, nextContext: any) {
        if (nextProps.errors) {
            this.setState((prevState) => ({
                ...prevState,
                errors: nextProps.errors.inputErrors,
            }));
        }
        if (nextProps.fields && nextProps.errors && nextProps.headerTitle !== this.props.headerTitle) {
            this.setState((prevState) => ({
                ...prevState,
                fieldDetails: nextProps.fields,
            }));
        }
    }

    public render() {
        return (
            <div>
                {this.props.headerTitle && <div style={this.props.customStyles.headerStyle}>
                    {this.props.headerTitle}
                </div>}
                <div>
                    {
                        this.state.fieldDetails.map((fieldDetails, index) => {
                            if (fieldDetails.inputType === InputType.TEXT || fieldDetails.inputType === InputType.NUMBER
                                || fieldDetails.inputType === InputType.PASSWORD) {
                                return (
                                    <InputTextField
                                        key={index}
                                        index={index}
                                        type={fieldDetails.inputType}
                                        placeholder={fieldDetails.placeholder}
                                        value={fieldDetails.value}
                                        fieldName={fieldDetails.name}
                                        onChangeHandler={this.handleChange}
                                        errorMsg={(this.state.errors && this.state.errors.hasOwnProperty(fieldDetails.name))
                                            ? this.state.errors[fieldDetails.name] : null}
                                        label = {fieldDetails.label}
                                        currentStyles={this.getCurrentStyles(fieldDetails.name, this.state.errors, "handleTextFieldStyle")}
                                        disabled={fieldDetails.disabled !== undefined ? fieldDetails.disabled : false}
                                    />
                                );
                            }

                            if (fieldDetails.inputType === InputType.DROPDOWN) {
                                return (
                                    <InputSelectField
                                        key={index}
                                        index={index}
                                        value={fieldDetails.value}
                                        fieldName={fieldDetails.name}
                                        onChangeHandler={this.handleChange}
                                        errorMsg={(this.state.errors && this.state.errors.hasOwnProperty(fieldDetails.name))
                                            ? this.state.errors[fieldDetails.name] : null}
                                        label = {fieldDetails.label}
                                        options={fieldDetails.options}
                                        currentStyles={this.getCurrentStyles(fieldDetails.name, this.state.errors, "handleDropdownStyle")}
                                        disabled={fieldDetails.disabled !== undefined ? fieldDetails.disabled : false}
                                    />
                                );
                            }

                            if (fieldDetails.inputType === InputType.RADIO) {
                                return (
                                    <RadioButtonField
                                        key={index}
                                        index={index}
                                        value={fieldDetails.value}
                                        fieldName={fieldDetails.name}
                                        onChangeHandler={this.handleChange}
                                        errorMsg={(this.state.errors && this.state.errors.hasOwnProperty(fieldDetails.name))
                                            ? this.state.errors[fieldDetails.name] : null}
                                        label = {fieldDetails.label}
                                        buttonList={fieldDetails.options}
                                        currentStyles={this.getCurrentStyles(fieldDetails.name, this.state.errors, "handleRadioStyle")}
                                        disabled={fieldDetails.disabled !== undefined ? fieldDetails.disabled : false}
                                    />
                                );
                            }
                            if (fieldDetails.inputType === InputType.FILE) {
                                return <UploadDoc
                                    key={index}
                                    index={index}
                                    type={fieldDetails.inputType}
                                    placeholder={fieldDetails.placeholder}
                                    value={fieldDetails.value}
                                    fieldName={fieldDetails.name}
                                    onChangeHandler={this.handleChange}
                                    errorMsg={(this.state.errors && this.state.errors.hasOwnProperty(fieldDetails.name))
                                        ? this.state.errors[fieldDetails.name] : null}
                                    label = {fieldDetails.label}
                                    currentStyles={this.getCurrentStyles(fieldDetails.name, this.state.errors, "handleUploadDocStyle")}
                                    successFullyUploaded={this.props.successfulyUploaded &&
                                        this.props.successfulyUploaded.includes(fieldDetails.name) ? true : false}
                                />;
                            }
                            if (fieldDetails.inputType === InputType.DATE) {
                                return <InputDateField
                                    key={index}
                                    index={index}
                                    placeholder={fieldDetails.placeholder}
                                    value={fieldDetails.value}
                                    fieldName={fieldDetails.name}
                                    onChangeHandler={this.handleChange}
                                    errorMsg={(this.state.errors && this.state.errors.hasOwnProperty(fieldDetails.name))
                                        ? this.state.errors[fieldDetails.name] : null}
                                    label = {fieldDetails.label}
                                    currentStyles={this.getCurrentStyles(fieldDetails.name, this.state.errors, "handleDateStyle")}
                                    isDatePicker={this.props.isDatePicker}
                                />;
                            }
                            if (fieldDetails.inputType === InputType.INFO_TEXT) {
                                return (
                                    <div>
                                        {fieldDetails.label}
                                        <hr/>
                                    </div>
                                );
                            }
                        })
                    }
                    { this.props.additionalBottomField && this.props.additionalBottomField}
                    {!this.props.hideDefaultSubmit &&
                    <button onClick={this.submitForm}
                            id="shubhSubmitBtn" style={this.props.customStyles.submitButtonStyle}
                    >{this.props.submitTitle ? this.props.submitTitle : "Submit"}</button>}
                </div>
            </div>
        );
    }
}
